import type { RouteObject } from 'react-router-dom';
import { lazyWithReload } from '@shared/lazyWithReload';
import LegacyConnectionPathRedirect from '@shared/components/LegacyConnectionPathRedirect';

const MyOrganizationPage = lazyWithReload(() => import('@organizations/presentation/pages/MyOrganizationPage'));
const ConnectionDetailsPage = lazyWithReload(() => import('@connections/presentation/pages/ConnectionDetailsPage'));
const SettingsPage = lazyWithReload(() => import('@shared/settings/pages/SettingsPage'));
// Registro incondicional (D1): el guard de flag+rol vive dentro de BillingPage, para que un
// deep-link con la flag apagada degrade a un redirect limpio al índice de la organización.
const BillingPage = lazyWithReload(() => import('@organizations/presentation/pages/BillingPage'));

export const orgRoutes: RouteObject[] = [
  { index: true, element: <MyOrganizationPage /> },
  { path: 'my-organization', element: <MyOrganizationPage /> },
  { path: 'connections/:id', element: <ConnectionDetailsPage /> },
  // Redirección permanente: marcadores y emails ya enviados (design D2).
  { path: 'klons/:id', element: <LegacyConnectionPathRedirect /> },
  { path: 'settings', element: <SettingsPage /> },
  { path: 'billing', element: <BillingPage /> },
];
